import React, { useEffect, useState } from "react";

function MbTagInput({
  value = [],
  onChange,
  placeholder,
  styles,
  paseSeparateChar = ",",
}) {
  const [tags, setTags] = useState(value);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (onChange) {
      onChange(tags);
    }
  }, [tags, onChange]);

  useEffect(() => {
    setTags(value);
  }, [value]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    if (pastedText) {
      const pastedTags = pastedText
        .split(paseSeparateChar)
        .map((tag) => tag.trim())
        .filter((tag) => tag && !tags.includes(tag));

      if (pastedTags.length > 0) {
        // Add the new tags to the existing tags
        setTags([...tags, ...pastedTags]);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = inputValue.trim();
      if (value && !tags.includes(value)) {
        setTags([...tags, value]);
        setInputValue("");
      }
    } else if (e.key === "Backspace" && inputValue === "" && tags.length > 0) {
      const newTags = [...tags];
      newTags.pop();
      setTags(newTags);
    }
  };

  const removeTag = (indexToRemove) => {
    const newTags = [...tags];
    newTags.splice(indexToRemove, 1);
    setTags(newTags);
  };

  return (
    <div>
      <div>
        {tags.map((tag, index) => (
          <div key={`tag-${index}-${tag}`} className="tag">
            {tag}
            <button
              className={styles.tagRemoveBtn}
              type="button"
              onClick={(e) => {
                // stop propagation to prevent multiple handlers being called
                e.preventDefault();
                e.stopPropagation();
                removeTag(index);
              }}
            >
              &times;
            </button>
          </div>
        ))}
        <input
          className={styles.userInput}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          placeholder={placeholder || "Type and press Enter to add tags"}
        />
      </div>
    </div>
  );
}

export default MbTagInput;
